import * as React from 'react';

import '../../styles/scaffold/Container.css';

export class Container extends React.PureComponent<{}> {
    public render() {
        return <div className="Container">{this.props.children}</div>;
    }
}
